import { LabeledInput } from '../labeled-input';

import { withSection } from './withSection';

export const SectionLabeledInput = withSection(LabeledInput);
